<app-breadcrumb [master]="'Administracja'" [parentName]="'Słownik'" [name]="'Import'"></app-breadcrumb>
<div class="identifier-import" fxLayout="column" fxLayoutGap="15px" [formGroup]="dynamicDictionaryImportForm">
  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100">

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100">
      <div fxLayout="row">
        <mat-card fxLayout="column" fxLayoutGap="15px" fxFlex="100">
          <div fxLayout="row">
            <h3>Dane importu</h3>
          </div>

          <div fxLayout="row" fxFlex="100">
            <app-file-drag-and-drop
              fxFlex="100"
              [acceptMime]="'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'"
              (fileSelected)="fileSelected($event)"
              [multiple]="false"
              [fileControl]="fileControl">
              <mat-icon matSuffix color="accent">attachment</mat-icon>
              <mat-error *ngIf="fileControl.hasError('required')">Wybierz plik</mat-error>
            </app-file-drag-and-drop>
          </div>

          <mat-error *ngIf="fileControl?.hasError('maxContentSize')">
            Całkowity rozmiar pliku nie może przekraczać
            {{fileControl.getError('maxContentSize').maxSize | byteFormat}}
            (Wybrany plik: {{fileControl.getError('maxContentSize').actualSize | byteFormat}}).
          </mat-error>

          <mat-error *ngIf="dynamicDictionaryImportForm.get('fileContent')?.hasError('backendError')">
            {{dynamicDictionaryImportForm.get('fileContent').getError('backendError')}}
          </mat-error>

          <div fxLayout="row">
            <app-dict
              fxFlex="100"
              label="Typ"
              dictType="dynamic_dictionary"
              [required]="true"
              [multiple]="false"
              [autoSelect]="false"
              [control]="dictControl"
            ></app-dict>
          </div>

        </mat-card>
      </div>
    </div>

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" *ngIf="dynamicDictionaryImport && dynamicDictionaryImport.progress !== 100">
      <div fxLayout="row">
        <mat-card fxLayout="column" fxLayoutGap="15px" fxFlex="100">
          <div fxLayout="row">
            <h3>Importowanie</h3>
          </div>

          <div fxLayout="row">
            <mat-progress-bar mode="determinate" [value]="dynamicDictionaryImport.progress"></mat-progress-bar>
          </div>
        </mat-card>
      </div>
    </div>

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" *ngIf="dynamicDictionaryImport && dynamicDictionaryImport.progress === 100 && dynamicDictionaryImport.result">
      <div fxLayout="row">
        <mat-card fxLayout="column" fxLayoutGap="15px" fxFlex="100">
          <div fxLayout="row">
            <h3>Wynik</h3>
          </div>

          <app-detail fxFlex="100" header="Zaimportowane">
            <ng-container *ngFor="let name of dynamicDictionaryImport.result.importedNames; let last = last">
              {{name}}<ng-container *ngIf="!last">, </ng-container>
            </ng-container>
            <ng-container *ngIf="!dynamicDictionaryImport.result.importedNames?.length"></ng-container>
          </app-detail>

          <app-detail fxFlex="100" header="Pominięte">
            <ng-container *ngFor="let name of dynamicDictionaryImport.result.duplicatedNames; let last = last">
              {{name}}<ng-container *ngIf="!last">, </ng-container>
            </ng-container>
            <ng-container *ngIf="!dynamicDictionaryImport.result.duplicatedNames?.length"></ng-container>
          </app-detail>

          <app-detail fxFlex="100" header="Przywrócone">
            <ng-container *ngFor="let name of dynamicDictionaryImport.result.restoredNames; let last = last">
              {{name}}<ng-container *ngIf="!last">, </ng-container>
            </ng-container>
            <ng-container *ngIf="!dynamicDictionaryImport.result.restoredNames?.length"></ng-container>
          </app-detail>

        </mat-card>
      </div>
    </div>
  </div>

  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="import()" [class.spinner]="processingRequest"
            [disabled]="dynamicDictionaryImportForm.invalid"
            mat-stroked-button color="primary">
      <mat-icon>publish</mat-icon> <span> Importuj</span>
    </button>
    <button (click)="cancel($event)" mat-stroked-button color="warn">
      <mat-icon>cancel</mat-icon> <span> Anuluj</span>
    </button>
  </div>
</div>
